import { defineMessages } from 'react-intl'

export const homeLicensesMessages = defineMessages({
  licenses: {
    id: 'homeLicenses.licenses',
    description: 'Title for Licenses of Home Licenses',
    defaultMessage: 'Licenses',
  },
  availableCodes: {
    id: 'homeLicenses.availableCodes',
    description: 'Title for Available Codes button of Home Licenses',
    defaultMessage: 'Available Codes',
  },
  usedCodes: {
    id: 'homeLicenses.usedCodes',
    description: 'Title for Used Codes button of Home Licenses',
    defaultMessage: 'Used Codes',
  },
  visitStore: {
    id: 'homeLicenses.visitStore',
    description: 'Title for Visit Store button of Home Licenses',
    defaultMessage: 'Visit Store',
  },
  searchPlaceholder: {
    id: 'homeLicenses.searchPlaceholder',
    description: 'Placeholder for search input of Home Licenses',
    defaultMessage: 'Search for licenses by code, order number, or notes...',
  },
  transferSearchPlaceholder: {
    id: 'homeDevicesMessages.transferSearchPlaceholder',
    description: 'Search Placeholder for license transfer dealers',
    defaultMessage: 'Search for dealers by name, phone, or email...',
  },
  purchasedLicenses: {
    id: 'homeLicenses.purchasedLicenses',
    description: 'Title for Purchased Lisecenses of Home Licenses',
    defaultMessage:
      'Purchased {domainName} Licenses will be displayed here when available.',
  },
  appliedLicenses: {
    id: 'homeLicenses.appliedLicenses',
    description: 'Title for Applied Lisecenses of Home Licenses',
    defaultMessage: 'Applied {domainName} Licenses will be displayed here.',
  },
  importLicense: {
    id: 'homeLicenses.importLicense',
    description:
      'A title of modal allowing to import license or button for open this modal',
    defaultMessage: 'Import License',
  },
  licenseCode: {
    id: 'homeLicenses.licenseCode',
    description:
      'A placeholder for text field inside modal window for importing licenses',
    defaultMessage: 'Import License',
  },
})
